// Centralized coordinate constants and conversion utilities
// 50 dots per meter is the editor's base unit (1 dot = 2cm)

/** Dots Per Meter — the editor's base unit scale */
export const DPM = 50

/** Inverse of DPM — multiply editor coords by this to get world meters */
export const DPM_SCALE = 1.0 / DPM

/** Grid snap granularity in dots (1 dot = 2cm) */
export const GRID_SNAP = 1

/**
 * Convert editor coordinates (dots) to Three.js world coordinates (meters)
 * Editor: X right, Y down | Three.js: X right, Y up, Z forward (into screen)
 */
export function editorToWorld(x: number, y: number, elevation: number = 0) {
  return {
    x: x * DPM_SCALE,
    y: elevation * DPM_SCALE,
    z: y * DPM_SCALE
  }
}

/**
 * Convert Three.js world coordinates (meters) to editor coordinates (dots)
 */
export function worldToEditor(x: number, y: number, z: number) {
  return {
    x: x / DPM_SCALE,
    y: z / DPM_SCALE,
    elevation: y / DPM_SCALE
  }
}
